// Utility functions to control Google Translate behavior
// Based on robust "Cookie + Reload" strategy

/**
 * Helper to delete a cookie with multiple path/domain variations
 */
const deleteCookie = (name) => {
  const hostname = window.location.hostname;
  document.cookie = name + '=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
  document.cookie = name + '=; Path=/; Domain=' + hostname + '; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
  document.cookie = name + '=; Path=/; Domain=.' + hostname + '; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
  
  // Also try clearing from root domain (e.g., .example.com if on www.example.com)
  const domainParts = hostname.split('.');
  if (domainParts.length > 2) {
    const rootDomain = '.' + domainParts.slice(-2).join('.');
    document.cookie = name + '=; Path=/; Domain=' + rootDomain + '; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
  }
};

/**
 * Triggers Google Translate to change the page language
 * Using the robust "Cookie + Reload" method found in Medivise
 * @param {string} languageCode - Language code ('en' or 'es')
 */
export const changeLanguage = (languageCode) => {
  console.log('Changing language to:', languageCode);
  
  if (languageCode === 'en') {
    // For English, we want to clear the translation cookie
    console.log('Clearing cookies for English...');
    deleteCookie('googtrans');
    deleteCookie('googtrans_legacy');
  } else {
    // For other languages, we set the cookie in the format Google Translate expects
    // format: /auto/targetLang
    const cookieValue = '/auto/' + languageCode;
    console.log('Setting cookie for', languageCode, ':', cookieValue);
    
    // Set cookie for current domain
    document.cookie = `googtrans=${cookieValue};path=/`;
    document.cookie = `googtrans=${cookieValue};path=/;domain=${window.location.hostname}`;
    
    // Also try setting for root domain (e.g. .example.com)
    const domainParts = window.location.hostname.split('.');
    if (domainParts.length > 1) {
      const rootDomain = '.' + domainParts.slice(-2).join('.');
      document.cookie = `googtrans=${cookieValue};path=/;domain=${rootDomain}`;
    }
  }

  // Force a reload to apply the new language configuration
  // This is required for Google Translate to pick up the cookie change reliably
  console.log('Reloading page to apply changes...');
  window.location.replace(window.location.href);
};

/**
 * Hides the Google Translate toolbar
 */
export const hideGoogleTranslateToolbar = () => {
  const style = document.createElement('style');
  style.id = 'google-translate-custom-style';
  style.innerHTML = `
    .goog-te-banner-frame,
    .goog-te-balloon-frame {
      display: none !important;
    }
    body {
      top: 0 !important;
      position: static !important;
    }
    .skiptranslate {
      display: none !important;
    }
    #google_translate_element {
      display: none !important;
    }
    .goog-te-spinner-pos {
      display: none !important;
    }
  `;
  
  const existingStyle = document.getElementById('google-translate-custom-style');
  if (existingStyle) {
    existingStyle.remove();
  }
  
  document.head.appendChild(style);
};

// Auto-hide toolbar on load
if (typeof window !== 'undefined') {
  window.addEventListener('load', () => {
    hideGoogleTranslateToolbar();
  });
}
